/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useEffect, useRef, useState } from 'react';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import GlobalContext from '../../../../../../components/Context/GloablContext';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useOnClickOutside } from '../../../../../../CommonMethods/OutsideClick';
import AnimatedButton from '../../../../../../components/Animation/AnimatedButton';
import FilterObserverBtn from '../Filter';
import ActivityExportObserver from '../Export';


const ObserverActivityHistoryTopBar = ({
    title,
    path,
    pathPlaceholder,
    SearchInput,
    AddButton,
    menuBar,
    handleApplyFilter,
    buttonName,
    ApplyFilter,
    suggestions,
    setSuggestions,
    optimizedFn,
    setFilterValues,
    filterValues,
    initialState,
    SearchPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    pathState,
    toAddScreen,
    isExport,
    setConfirmationState, data, exportObservers, isIdexport, isFilterOrganization }) => {
    const { setToastmessage, Toastmessage, toastErrorMessage, setToastErrorMessage, isSideBar } = useContext(GlobalContext);
    const navigate = useNavigate()
    const fileInputRef = useRef(null);
    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const [isHover, setIsHover] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state.MultiSelectSlice.selectedRows.selectedIds)
    const filtervals = useSelector(state => state.systemConfigData.filterState)
    const [dateError, setdateError] = useState(false)
    const ref = useRef()
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })

    const handleOpenFilter = () => {
        setdateError(false)
        if (isFilterOrganization) {
            if ((searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) && !isFilterOpen) {
                setFilterValues(filtervals)

            }
            else if (searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
                setFilterValues({
                    "filter_start_date": '',
                    "filter_end_date": '',
                })
            }

        } else {
            if ((searchParams.get("field") !== null || searchParams.get("action") !== null || searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) && !isFilterOpen) {
                setFilterValues(filtervals)
            }
            else if (searchParams.get("field") === null && searchParams.get("user_name") === null && searchParams.get("action") === null && searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
                setFilterValues({
                    "filter_start_date": '',
                    "filter_end_date": '',
                    // 'user_name': '',
                    // 'column_field': '',
                    // 'action_performed': ''

                })
            }

        }

        setIsFilterOpen(!isFilterOpen)
    }





    return (
        <div className="flex justify-between items-center mb-[14px]">
            {title !== undefined ?
                <h1 className="text-xl font-normal text-[#000000] min-w-fit">{title}</h1>
                :
                pathPlaceholder &&
                <Link to={path} state={pathState !== undefined ? pathState : (username && path !== '/manage-observer/' ? [username] : null)} className='flex items-center min-w-max'>
                    <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                    <span className='text-sm font-normal text-[#008586] ml-3'>{pathPlaceholder}</span>
                </Link>
            }
            <div className="flex items-center w-full justify-end relative">
                {/* <div className="relative ml-2.5">
                    <label htmlFor="input"></label>
                    <input
                        maxLength={90}
                        type="text"
                        id="search-value"
                        autoComplete='off'
                        value={suggestions}
                        autoFocus={suggestions !== ''}
                        onChange={(e) => { setSuggestions(e.target.value); optimizedFn(e.target.value) }}
                        className="pl-10 pr-[31px] w-[222px] py-2.5 border border-[#972E4C] rounded-[16px] placeholder:text-xs placeholder:font-normal placeholder:text-[#52555D] text-base font-normal text-[#000B17] outline-0" placeholder={SearchPlaceholder} />
                    <img src="/images/search_red.svg" alt="icon" className="absolute top-1/2 -translate-y-1/2 left-3" />
                    <button onClick={() => { setSuggestions(""); optimizedFn("") }}>
                        {suggestions !== "" && <img src="/images/clear_search.svg" alt="icon" className="absolute top-1/2 -translate-y-1/2 right-2.5" />}
                    </button>


                    {/* <!-- <button className="absolute top-[50%] -translate-y-[50%] right-3.5 inline-block">
                            <img loading="lazy" decoding="async" src="images/search.svg" alt="img"/>
                        </button> --> 

        </div> */}
                {(ApplyFilter !== undefined && ApplyFilter) &&
                    <FilterObserverBtn
                        dateError={dateError}
                        setdateError={setdateError}
                        isFilterOpen={isFilterOpen}
                        setIsFilterOpen={setIsFilterOpen}
                        handleApplyFilter={handleApplyFilter}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        initialState={initialState}
                        handleOpenFilter={handleOpenFilter} />
                }
                {(SearchInput || isExport) && data !== undefined && data?.data?.length > 0 && <div>  <ActivityExportObserver
                    selectedRows={selectedRows}
                    exportObservers={exportObservers}
                    exportCols={exportCols}
                    setIsFilterOpen={setIsFilterOpen}
                    isColumnSelect={isColumnSelect}
                    setIsColumnSelect={setIsColumnSelect}
                    isIdexport={isIdexport} username={username}
                    TotalCount={data?.total_count} />
                </div>}

                {/* {isExport && } after export only tis button show */}
                {/* {<Link to={`/export-history/${username}`} >
                    <button type='button'
                        disabled={true}
                        id="activity_history"
                        className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
                           bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                        View Export History
                    </button>
                </Link>} */}
                {AddButton &&
                    <>{<Link to={toAddScreen} state={{ "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"), 'search': searchParams.get("search") ? searchParams.get("search") : '' }}>
                        <button type='button'
                            id="Add user"
                            className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
    bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                            <span className="mr-2.5"><img src="/images/add_Icon_white.svg" alt="img" /></span>
                            {buttonName}
                        </button>
                    </Link>}</>}
            </div>
        </div>
    );
}

export default ObserverActivityHistoryTopBar;
